import React, { Fragment, Component } from 'react';
import PropTypes, {
  arrayOf, shape, string, func,
} from 'prop-types';
import { TabFilterSettings } from 'components/common';
import PressReleaseContent from './PressReleaseContent';
import MediaCoverageContent from './MediaCoverageContent';
import LatestUpdatesContent from './LatestUpdatesContent';
import YearButtonsFilter from './YearButtonsFilter';

class PressPageTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIdx: 0,
      yearFilter: new Date().getFullYear()
        .toString(),
      yearButtonFilter: {
        yearButtonCount: [0, 1, 2],
        activeYearButtonIdx: 0,
      },
    };
  }

  getComponent(key) {
    const { children } = this.props;
    return children.filter(component => component.key === key);
  }

  onChangeTabs = (tabIdx, tabLabel) => {
    const { updateTitle } = this.props;
    if (updateTitle) {
      updateTitle(tabLabel);
    }
    this.setState({
      activeTabIdx: tabIdx,
    });
  };

  onYearSelection = (year, activeYearIdx) => {
    this.setState(prevState => ({
      yearFilter: year.toString(),
      yearButtonFilter: {
        ...prevState.yearButtonFilter,
        activeYearButtonIdx: activeYearIdx,
      },
    }));
  };

  render() {
    const {
      pressRelease, mediaCoverage, latestUpdates, categoryTabs, buttonContent, nothingToShow,
    } = this.props;
    const { activeTabIdx, yearFilter, yearButtonFilter } = this.state;

    return (
      <Fragment>
        <TabFilterSettings
          onChange={this.onChangeTabs}
          tabs={categoryTabs.map(item => item.label)}
        />
        <div>
          {activeTabIdx !== 2
            ? (
              <YearButtonsFilter
                onYearSelection={this.onYearSelection}
                yearButtonFilter={yearButtonFilter}
                btnContent={buttonContent}
              />
            ) : null
          }
        </div>
        {activeTabIdx === 0
        && (
          <PressReleaseContent
            content={pressRelease}
            yearFilter={yearFilter}
            nothingToShow={nothingToShow}
          />
        )}
        {activeTabIdx === 1
        && (
          <MediaCoverageContent
            content={mediaCoverage}
            yearFilter={yearFilter}
            nothingToShow={nothingToShow}
          />
        )}
        {activeTabIdx === 2
        && (
          <LatestUpdatesContent
            content={latestUpdates}
            nothingToShow={nothingToShow}
          />
        )}
      </Fragment>
    );
  }
}

PressPageTemplate.propTypes = {
  pressRelease: arrayOf(shape({
    title: string,
    year: string,
    type: string,
    link: string,
    content: shape({}),
  })),
  mediaCoverage: arrayOf(shape({
    title: string,
    year: string,
    type: string,
    link: string,
  })),
  latestUpdates: arrayOf(shape({
    title: string,
    link: string,
    year: string,
  })),
  categoryTabs: arrayOf(shape({
    label: string,
    keyword: string,
  })),
  updateTitle: func,
  children: PropTypes.node,
  buttonContent: string,
  nothingToShow: string,
};

PressPageTemplate.defaultProps = {
  pressRelease: null,
  mediaCoverage: null,
  latestUpdates: null,
  categoryTabs: null,
  children: null,
  updateTitle: null,
  buttonContent: null,
  nothingToShow: null,
};

export default PressPageTemplate;
